import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { createTheme } from "@mui/material/styles";
import * as React from "react";

import { ImageCard } from "./ImageCard";
import MultiImageUpload from "./MutliImageUpload";

const theme = createTheme();

export default function UploadImage({ onChange, data }) {
  const [images, setImageList] = React.useState([]);

  const handleSetImageList = (newImages) => {
    console.log("newImages", newImages);
    setImageList(newImages);
    onChange(newImages);
  };

  return (
    <Container sx={{ mb: "4.5rem" }} component="main" maxWidth="xs">
      <Box component="form" sx={{ mt: 1 }}>
        {images.length === 0 && (
          <Box
            style={{ marginTop: "2rem" }}
            border={"1px solid rgba(0,0,0,0.25)"}
            borderRadius={1}
            padding={3}
          >
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              xs={12}
              spacing={1}
            >
              <Grid item container xs={12} justifyContent="center">
                {/* <SingleImageUpload setImageList={setImageList} /> */}
                <MultiImageUpload setImageList={handleSetImageList} />
              </Grid>
            </Grid>
          </Box>
        )}

        {images.length > 0 && (
          <Box sx={{ pt: "1rem", pb: "1rem", flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {images.map((image, index) => (
                  <ImageCard
                    key={index}
                    image={image}
                    isFirstElement={index === 0}
                    isLastElement={index === images.length - 1}
                    handleChangeOrderUp={() => {}}
                    handleChangeOrderDown={() => {}}
                    handleDeleteImage={() => {
                      const newImages = [...images];
                      newImages.splice(index, 1);
                      handleSetImageList(newImages);
                    }}
                  />
                ))}
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </Container>
  );
}
